import { trans } from '@spotahome/soyuz/client';
import { DSIcon } from '@spotahome/ui-library/base';

import './SimpleValuePropositions.scss';

const ITEMS = [
  {
    key: 'no-charge',
    icon: 'person_add',
    transKey: 'listing.simple-vp.no-charge'
  },
  {
    key: 'free-cancellation',
    icon: 'verified_user',
    transKey: 'listing.simple-vp.free-cancellation'
  },
  {
    key: 'landlord-reply',
    icon: 'quick_phrases',
    transKey: 'listing.simple-vp.landlord-reply'
  }
];

const SimpleValuePropositions = () => (
  <ul className="simple-value-propositions">
    {ITEMS.map(({ key, icon, transKey }) => (
      <li key={key} className="simple-value-propositions__item">
        <DSIcon name={icon} size="m" />
        <span className="simple-value-propositions__text">{trans(transKey)}</span>
      </li>
    ))}
  </ul>
);

export default SimpleValuePropositions;
